import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { SortEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import { Observable, tap } from 'rxjs';
import { PeopleService } from 'src/app/services/people.service';
import { AppConstants } from 'src/app/shared/app.constants';

@Component({
  selector: 'ness-person-search-results',
  templateUrl: './person-search-results.component.html'
})
export class PersonSearchResultsComponent {
  @Output() viewPersonIDDetails: EventEmitter<string> = new EventEmitter();
  @ViewChild('dt', { static: false }) peopleTable: Table;

  defaultTableRows: number = AppConstants.defaultTableRows;
  matchingPeopleResult$: Observable<ServerModels.ENESS_PersonDTO[]> = this.peopleService.findPeopleResult$.pipe(tap((x: ServerModels.ENESS_PersonDTO[]) => this.peopleTable?.reset()));
  matchingPeopleResultCols = [
    { field: 'ENESS_XREF_PeopleFBIFileNumbers', header: 'FBI #' },
    { field: 'ENESS_XREF_PeopleStateIDNumbers', header: 'State ID' },
    { field: 'LastName', header: 'Last Name' },
    { field: 'FirstName', header: 'First Name' },
    { field: 'DateOfBirth', header: 'Birth Date' },
    { field: 'SSN', header: 'SSN' }
  ];

  constructor(private peopleService: PeopleService) { }

  public viewPersonDetails(personId: string): void {
    this.viewPersonIDDetails.emit(personId);
  }

  public peopleResultsSort(sortEvt: SortEvent): void {
    sortEvt.data.sort((data1: ServerModels.ENESS_PersonDTO, data2: ServerModels.ENESS_PersonDTO) => {
      let result = null;
      let value1 = data1[sortEvt.field];
      let value2 = data2[sortEvt.field];

      if (sortEvt.field == 'ENESS_XREF_PeopleFBIFileNumbers') {
        let fbiFileNumber1 = data1[sortEvt.field].map(x => x.FBIFileNumber) as string[];
        let fbiFileNumber2 = data2[sortEvt.field].map(x => x.FBIFileNumber) as string[];
        value1 = fbiFileNumber1.join('');
        value2 = fbiFileNumber2.join('');
      }

      if (sortEvt.field == 'ENESS_XREF_PeopleStateIDNumbers') {
        let stateIdNumber1 = data1[sortEvt.field].map(x => `${x.StateAbbreviation}${x.StateIDNumbers}`) as string[];
        let stateIdNumber2 = data2[sortEvt.field].map(x => `${x.StateAbbreviation}${x.StateIDNumbers}`) as string[];
        value1 = stateIdNumber1.join('');
        value2 = stateIdNumber2.join('');
      }

      if (value1 == null && value2 != null)
        result = -1;
      else if (value1 != null && value2 == null)
        result = 1;
      else if (value1 == null && value2 == null)
        result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string')
        result = value1.localeCompare(value2);
      else
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

      return (sortEvt.order * result);
    });
  }
}
